var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGlobalProvide4 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "global-provide-4_svg__a",
  width: 40,
  height: 40,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M39.09 0H.91v40H39.09z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#408BFC",
  mask: "url(#global-provide-4_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M30.384 16.857c2.334-2.355 3.085-4.747 3.14-6.655.056-2-.123-2.872-.544-3.297-.421-.424-1.286-.606-3.268-.548-1.892.054-4.263.812-6.597 3.167L12.05 20.686a2.64 2.64 0 0 1-3.136.464L4.773 18.9c-.433-.235-.518-.821-.147-1.147 2.56-2.25 8.03-5.769 11.856-3.633l5.594-5.643c5.192-5.238 10.384-4.19 11.942-2.62 1.558 1.572 2.596 6.81-2.596 12.048l-2.797 2.822-2.797 2.821c2.117 3.86-1.371 9.378-3.601 11.96-.323.375-.905.29-1.138-.147l-2.23-4.178a2.7 2.7 0 0 1 .46-3.164zM20.083 29.344a.67.67 0 0 0-.115.79l1.388 2.601a.636.636 0 0 0 1.09.077c.813-1.18 1.605-2.584 2.092-4.005.4-1.166.563-2.231.439-3.171-.062-.475-.624-.6-.96-.26zM14.67 15.947c.336-.339.213-.905-.258-.968-.932-.125-1.988.04-3.144.443-1.408.49-2.8 1.29-3.97 2.11-.394.277-.347.87.076 1.1l2.578 1.4a.66.66 0 0 0 .784-.116z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "m21.037 28.38-9.345-9.427L10.653 20 20 29.428zM13.25 25.762l-7.27 7.333a.745.745 0 0 0 0 1.047.73.73 0 0 0 1.039 0l7.269-7.333a.745.745 0 0 0 0-1.047.73.73 0 0 0-1.039 0M15.326 27.857l-2.596 2.619a.745.745 0 0 0 0 1.047.73.73 0 0 0 1.039 0l2.596-2.619a.745.745 0 0 0 0-1.047.73.73 0 0 0-1.039 0M11.173 23.667 6.5 28.38a.745.745 0 0 0 0 1.047.73.73 0 0 0 1.038 0l4.673-4.714a.745.745 0 0 0 0-1.047.73.73 0 0 0-1.038 0M26.23 13.714a2.19 2.19 0 0 0 3.116 0c.86-.868.86-2.275 0-3.143a2.19 2.19 0 0 0-3.116 0 2.236 2.236 0 0 0 0 3.143"
}))));
export default SvgGlobalProvide4;